import { FeaturesConfig } from '@spartacus/core';

export const featuresConfig: FeaturesConfig = {
  features: {
    level: '2.0',
  },
};
